import React, { useContext, useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Cookies from "js-cookie";

import Purple_border_btn from "../../../common_components/common_btn/purple_border_btn/Purple_border_btn";
import Purple_Btn from "../../../common_components/common_btn/purple_btn/Purple_Btn";
import Uploaded_img_holder from "../../../common_components/uploaded_img_holder/Uploaded_img_holder";
import {
  getBespokeProgress,
  postBespokeStep4,
} from "../../../../utils/apis/BespokeGift/bespoke_gift";
import { Context } from "../../../../utils/context";
import SuccessfullyModal from "../../../../components/Common-Component/Commonmodal/SuccessfullyModal/SuccessfullyModal";
import Error_Modal from "../../../../components/Common-Component/Commonmodal/Error_modal/Error_Modal";
import { useNavigate } from "react-router-dom";

function Step_4({ handleNext, handleBack }) {
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const { IMG_URL } = useContext(Context);

  const [existingImages, setExistingImages] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [success, setSuccsuccess] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      order_reference: "",
      payment_mode: "",
      color_images: [],
    },
  });

  const paymentMode = watch("payment_mode");

  useEffect(() => {
    const draftId = Cookies.get("draftId");
    if (!draftId) return;

    const fetchDraft = async () => {
      try {
        const res = await getBespokeProgress(draftId);
        if (res?.success) {
          const data = res.data;

          reset({
            ...data,
            order_reference: data?.order_reference || "",
            payment_mode: data?.payment_mode || "",
          });

          if (Array.isArray(data?.bespoke_order_colors)) {
            setValue(
              "images",
              data.bespoke_order_colors?.map((item) => IMG_URL + item?.image) ||
                [],
            );
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDraft();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    setApiError(null);

    try {
      const formData = new FormData();
      formData.append("draft_id", Cookies.get("draftId") || "");
      formData.append("order_reference", data.order_reference || "");
      formData.append("payment_mode", data.payment_mode);

      if (uploadedImages?.length) {
        uploadedImages.forEach((file) => formData.append("color", file.file));
      }

      const res = await postBespokeStep4(data?.id, formData);

      if (res?.success) {
        setSuccsuccess(res?.message);

        const draftId = res?.data?.draftId;

        if (draftId) {
          Cookies.set("draftId", draftId, { expires: 1, path: "/" });
        }

        setTimeout(() => {
          Cookies.remove("draftId");
          navigate("/");
        }, 3000);
      } else {
        setApiError(res?.message || "Failed to save. Please try again.");
      }
    } catch (err) {
      setApiError(err?.message || "Failed to save. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const imageFiles = watch("images");

  return (
    <>
      <section className="step_form_content">
        <Form>
          <Row className="gy-4">
            <Col md={12}>
              <Form.Group className="form_group">
                {/* <Form.Label>Order ID / Reference</Form.Label> */}
                <Form.Label>Font Style / Engraving Type</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Font Style / Engraving Type"
                  isInvalid={!!errors.order_reference}
                  {...register("order_reference")}
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                <Form.Label>Payment Mode*</Form.Label>

                <input
                  type="hidden"
                  {...register("payment_mode", {
                    required: "Please select a payment mode",
                  })}
                />

                <div className="upload_box_wrap d-flex gap-5">
                  {["COD", "Online"].map((mode) => (
                    <Form.Group key={mode}>
                      <Form.Check
                        type="radio"
                        id={`payment-${mode}`}
                        label={mode}
                        name="payment_mode"
                        value={mode}
                        checked={paymentMode === mode}
                        onChange={() =>
                          setValue("payment_mode", mode, {
                            shouldValidate: true,
                          })
                        }
                      />
                    </Form.Group>
                  ))}
                </div>

                {errors.payment_mode && (
                  <div className="invalid-feedback d-block mt-1">
                    {errors.payment_mode.message}
                  </div>
                )}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="form_group">
                {/* <Form.Label>Color / Design Preference</Form.Label> */}
                <Form.Label>Upload Your Logo</Form.Label>
                <Uploaded_img_holder
                  imageFiles={imageFiles}
                  setUploadedImages={setUploadedImages}
                  uploadedImages={uploadedImages}
                />
              </Form.Group>
            </Col>
          </Row>

          {apiError && (
            <div className="alert alert-danger mt-3 py-2" role="alert">
              {apiError}
            </div>
          )}
        </Form>
      </section>

      <div className="btn_holder">
        <Purple_border_btn onClick={handleBack} btnText="Back" />
        <Purple_Btn
          onClick={handleSubmit(onSubmit)}
          btnText={loading ? "Saving..." : "Save & Next"}
          disabled={loading}
        />
      </div>

      <SuccessfullyModal show={success} text={success} />
      <Error_Modal show={apiError} text={apiError} />
    </>
  );
}

export default Step_4;
